export default (name, index = false) => () => import(`@/view/${name}${index ? '/index' : ''}.vue`)



// WEBPACK FOOTER //
// ./src/router/route.js